import React, { useCallback, useRef } from 'react'
import { useMemo } from 'react'
import GenericTable, {
  GenericTableHandle
} from '../../../../components/GenericTable'
import { useAuth } from '../../../../context/Auth'
import {
  PaginatedResponse,
  PaginationMeta
} from '../../../../interfaces/PaginatedResponse'
import workflowsColumns from './Columns'
import { list } from '../../../../lib/fetch/workflows'
import Workflow from '../../../../interfaces/Workflow'

export default function WorkflowsTable() {
  const ref = useRef<GenericTableHandle>(null)
  const refetch = useCallback(() => {
    ref.current?.refetch()
  }, [ref])
  const columns = useMemo(() => workflowsColumns(refetch), [refetch])
  const [{ token }] = useAuth()
  const fetch = useCallback(
    async (
      paginationMeta: PaginationMeta
    ): Promise<PaginatedResponse<Workflow> | string> => {
      let result
      try {
        result = await list({
          token
        })
      } catch (error) {
        let message = 'Error'
        if (error instanceof Error) {
          message = error.message
        }
        result = message
      }
      return result
    },
    [token]
  )

  return <GenericTable columns={columns} onFetch={fetch} ref={ref} />
}
